module.exports = __webpack_public_path__ + "img/button_right.e499e68b.svg";